import React from "react";

export interface ICategoryObject {
    name: string;
    url: string;
}

export function scrollToElementByClassName(className: string) {
    const elementsArray = document.getElementsByClassName(className);

    if (elementsArray.length) {
        const selectedElement = <HTMLElement>elementsArray[0];
        const scroller = selectedElement.parentElement;
        let targetScroll = (selectedElement.offsetLeft + (selectedElement.offsetWidth / 2)) - (scroller.offsetWidth / 2);
        targetScroll = Math.min(targetScroll, scroller.scrollWidth);

        if (targetScroll == scroller.scrollLeft) {
            return;
        }

        scroller.scrollLeft = targetScroll;
    }
}

export function getChildUrlSet(children) {
    return new Set(React.Children.map(children, (child) => {
        return child.props.url.toLowerCase();
    }));
}

export function getSelectedLinkParam(children, param) {
    if (window) {
        const categorySet = getChildUrlSet(children);
        const category = getUrlParams(param);

        if (category && categorySet.has(category)) {
            return category;
        } else {
            return null;
        }
    }
}

export function getUrlParams(param = null) {
    if (window) {
        const url = new URL(window.location.href);
        let params = new URLSearchParams(url.search.slice(1));

        if (!param) {
            return params.entries();
        } else {
            return params.get(param)?.toLowerCase();
        }
    }
}

export function isLink(url) {
    return /^(https:\/\/|\/)/i.test(url);
}